'use strict';

var React = require('react');

var SvgBillingStatementRupeeMajor = function SvgBillingStatementRupeeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.889 13.143a.75.75 0 0 0-.246-1.032l-1.713-1.054a2.485 2.485 0 0 0 1.07-2.045v-.012h1.25a.75.75 0 0 0 0-1.5h-1.25v-1h1.25a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h1.75v1h-1.75a.75.75 0 0 0 0 1.5h1.75v.012a.988.988 0 0 1-.988.988c-.903 0-1.238 1.184-.47 1.657l2.815 1.732a.75.75 0 0 0 1.032-.246Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 16a1.5 1.5 0 0 0 2.615 1.003l1.135-1.26 1.135 1.26a1.5 1.5 0 0 0 2.23 0l1.135-1.26 1.135 1.26a1.5 1.5 0 0 0 2.615-1.003v-11a2.5 2.5 0 0 0-2.5-2.5h-7a2.5 2.5 0 0 0-2.5 2.5v11Zm8.149-2h.203a.995.995 0 0 1 .641.326l1.507 1.674v-11a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v11l1.507-1.674a.995.995 0 0 1 .641-.326h.204a.995.995 0 0 1 .641.326l1.507 1.674 1.507-1.674a.995.995 0 0 1 .642-.326Z"
  }));
};
SvgBillingStatementRupeeMajor.displayName = "BillingStatementRupeeMajor";

exports.SvgBillingStatementRupeeMajor = SvgBillingStatementRupeeMajor;
